<template>
  <div class="coupon-list flex-column height-full p-lr-15 p-b-15">
    <div class="flex1 overflow-auto m-t-10">
      <div class="search-box">
        <div class="left">
          <el-select
            size="mini"
            @change="paramsChange"
            multiple
            clearable
            collapse-tags
            placeholder="请选择"
            v-model="couponStatusValue"
          >
            <el-option
              v-for="item in couponStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select size="mini" @change="paramsChange" clearable placeholder="请选择" v-model="params.type">
            <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-checkbox @change="paramsChange" v-model="params.newly">新到账</el-checkbox>
          <el-checkbox @change="paramsChange" v-model="params.expiring">即将过期</el-checkbox>
          <el-checkbox @change="paramsChange" v-model="params.best">最优惠</el-checkbox>
        </div>
        <span class="getMoreCoupon" @click="$router.push({ path: '/new-products/coupon-center' })"
          >领取更多优惠券>></span
        >
      </div>
      <template v-for="(item, index) in couponList">
        <CouponItem :key="index" :couponInfo="item" :type="couponType" @clickBottom="handleClick">
          <template #btn>
            {{ filterStatus(item) }}
          </template>
        </CouponItem>
      </template>
      <div v-if="!couponList.length" class="flex flex-center text-999 noData">暂无数据</div>
    </div>
    <div class="text-center m-t-10">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total,  prev, pager, next, jumper, sizes"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import CouponItem from "@/components/Coupon/CouponItem";

import { getCustomerCouponList } from "@/api/coupon";

export default {
  name: "CouponList",
  components: {
    CouponItem
  },
  data() {
    return {
      page: 1,
      pageSize: 20,
      total: 0,
      couponList: [],
      couponType: "client",
      couponStatusValue: ["available"],
      couponStatus: [
        { label: "可用优惠券", value: "available" },
        { label: "已用优惠券", value: "used" },
        { label: "已失效优惠券", value: "expired" },
        { label: "已作废优惠券", value: "canceled" }
      ],
      typeList: [
        {
          label: "全部",
          value: "all"
        },
        {
          label: "满减",
          value: "reduce"
        },
        {
          label: "折扣",
          value: "discount"
        }
      ],
      params: {
        type: "all",
        best: false,
        expiring: false,
        newly: false
      }
    };
  },
  mounted() {
    this.getCustomerCouponListFn();
  },
  methods: {
    paramsChange() {
      this.page = 1;
      this.getCustomerCouponListFn();
    },
    handleClick(item) {
      if (item.status === "normal") {
        this.$store.commit("search/setSearchData", {
          couponId: item.id,
          type: -1
        });
        this.$router.push({ path: "/new-products/product-list" });
      }
    },
    filterStatus(item) {
      let name = "";
      switch (item.status) {
        case "normal":
          name = "立即使用";
          break;
        case "expired":
          name = "已失效";
          break;
        case "used":
          name = "已使用";
          break;
        case "canceled":
          name = "已作废";
          break;
        default:
          break;
      }
      return name;
    },
    getCustomerCouponListFn() {
      const params = {
        page: this.page,
        pageSize: this.pageSize,
        ...this.params
      };
      if (this.couponStatusValue && this.couponStatusValue.length > 0) {
        this.couponStatusValue.forEach(key => {
          params[key] = true;
        });
      }
      getCustomerCouponList(params)
        .then(res => {
          this.couponList = res.rows || [];
          this.total = res.totalSize || 0;
        })
        .catch(err => {
          this.$message.error(err?.message);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCustomerCouponListFn();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getCustomerCouponListFn();
    }
  }
};
</script>

<style lang="less" scoped>
.coupon-list {
  box-sizing: border-box;
}
.noData {
  height: calc(100% - 100px);
}
.search-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px dashed #ccc;
  .left {
    display: flex;
    gap: 4px 8px;
    align-items: center;
    flex: 1;
    max-width: calc(100% - 118px);
  }
  .getMoreCoupon {
    width: 115px;
    flex-shrink: 0;
    font-size: 14px;
    color: #fe7448;
    cursor: pointer;
  }
}
</style>
